import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect, useState } from "react";
import { externalWithdrawsSchema } from "../../lib/validation";
import CustomPayemntNumberInput from "../../ui/payment/CustomPayemntNumberInput";
import Loader from "../../shared/Loader";
import { useExternalWithdraw } from "../../lib/queries/queriesAndMutations";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import WithdrawIbanInput from "./WithdrawIbanInput";
import TextArea from "../../ui/TextArea";
import CustomPaymentInput from "../../ui/payment/CustomPaymentInput";
import { useNavigate } from "react-router-dom";

export default function ExternalTransferForm({ initial }) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const {
    watch,
    setValue,
    clearErrors,
    reset,
    control,
    register,
    handleSubmit,
    setFocus,
    formState: { errors },
  } = useForm({
    defaultValues: {
      amount: "",
      iban: initial?.iban ?? "",
      iban_nickname: initial?.iban_nickname ?? "",
      description: "",
    },
    resolver: zodResolver(externalWithdrawsSchema),
  });

  const { mutateAsync: externalWithdraw, isPending } = useExternalWithdraw();

  useEffect(() => {
    console.log("focus")
    setFocus("amount")
  }, [setFocus])
  

  const processForm = async (data) => {
    // if (removeLoSt(data?.amount) > balance) {
    //   alert("موجودی ناکافی");
    //   return;
    // }
    try {
      const res = await externalWithdraw(data);

      if (res?.status === 200 || res?.status === 201) {
        navigate("/withdrawals/list");
        queryClient.invalidateQueries({ queryKey: ["getMoneyTransferReqs"] });
        queryClient.invalidateQueries({
          queryKey: ["getUserAvailabelBalance"],
        });
        toast.success("با موفقیت ثبت شد");

        reset();
      }
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <form
      onSubmit={handleSubmit(processForm)}
      className="flex flex-col w-full gap-3 "
    >
      <CustomPayemntNumberInput
        control={control}
        name={"amount"}
        label={"مبلغ (ریال)*"}
        placeholder={"مبلغ به ریال"}
        type={"number"}
        errors={errors.amount}
      />

      <WithdrawIbanInput
        control={control}
        setValue={setValue}
        clearErrors={clearErrors}
        name="iban"
        value={watch("iban")}
        label=" شماره شبا"
        placeholder="کد شبای ۲۴ رقمی"
        type="text"
        errors={errors.iban}
        isSheba={true}
      />
      <CustomPaymentInput
        register={register}
        placeholder={"نامی مستعار برای دریافت کننده اختیاری"}
        control={control}
        name={"iban_nickname"}
        label={"نام مستعار (اختیاری)"}
        type={"text"}
        errors={errors.iban_nickname}
      />
      <TextArea
        control={control}
        placeholder={"توضیحات خود را اینجا بنویسید"}
        name={"description"}
        label={"شرح تراکنش"}
        type={"text"}
      />

      <div className="flex gap-1 mr-auto ">
        <button
          className="secondary-btn"
          onClick={(e) => {
            e.preventDefault();
            navigate("/withdrawals/list");
          }}
        >
          بازگشت
        </button>
        <button type="submit" className="primary-btn disabled:bg-slate-500 " disabled={isPending}>
          {isPending ? (
            <p className="flex gap-1 ">
              <div className="w-6 h-6">
                <Loader />
              </div>{" "}
            </p>
          ) : (
            "درخواست انتقال"
          )}
        </button>
      </div>
    </form>
  );
}
